import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';
import Config from './config';
import { StoreProvider } from "./useStore";
import QuickShop from './components/QuickShop';


class App extends Component {
  render() {
    return (
      <CookiesProvider>
        <StoreProvider>
          <Router basename={Config.basename}>
            <Route path="/" component={QuickShop} strict />
          </Router>
        </StoreProvider>
      </CookiesProvider>
    )
  }
}
export default App
